<template lang="pug">
div(class="flex flex-col space-y-2.5")
  base-snackbar(
    :errors.sync="expenseCategoryPostErrors"
  )
  v-text-field(
    outlined
    dense
    hide-details="auto"
    label="Description"
    v-model="description"
    :error-messages="expenseCategoryPostErrors.description"
  )
  v-btn(
    :color="editMode ? 'yellow darken-3' : 'primary'"
    dense
    dark
    :loading="expenseCategoryPosting"
    @click="sendExpenseCategoryRequest"
  )
    span {{ editMode ? 'Update' : 'Save' }}
  v-btn(
    v-if="editMode"
    color="error"
    dense
    dark
    @click="cancelEditMode"
  )
    span Cancel
</template>
<script>
import VueRequestHandler from '@/classes/VueRequestHandler.class'
import requestVars from '@/extra-functions/request-vars.extra'
import expenseCategoryRepository from '@/repositories/expense-category.repository'

const [expenseCategoryPostVars, expenseCategoryPostVarNames] = requestVars({ identifier: 'expense-category', request: 'post', hasData: false })
const expenseCategoryHandler = new VueRequestHandler(null, expenseCategoryPostVarNames)

const inputVars = () => ({
  id: null,
  description: null,
})
export default {
  name: 'CreateExpenseCategory',
  props: {
    edit: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    ...inputVars(),
    ...expenseCategoryPostVars,
  }),
  computed: {
    editMode() {
      return !this.$objectEmpty(this.edit)
    },
  },
  watch: {
    edit(item) {
      this.populateInputs(item)
    },
  },
  methods: {
    cancelEditMode() {
      this.$emit('update:edit', {})
      // this.resetInputs()
    },
    sendExpenseCategoryRequest() {
      if (this.editMode) {
        this.updateExpenseCategory()
        return
      }
      this.storeExpenseCategory()
    },
    storeExpenseCategory() {
      const handler = expenseCategoryHandler
      const repository = expenseCategoryRepository.store
      const { data } = this.getInputData()
      handler.setVue(this)
      handler.execute(repository, [data])
    },
    updateExpenseCategory() {
      const handler = expenseCategoryHandler
      const repository = expenseCategoryRepository.update
      const { id, data } = this.getInputData()
      handler.setVue(this)
      handler.execute(repository, [id, data])
    },
    getInputData() {
      const { id, description } = this
      const data = { description }
      return { id, data }
    },
    resetInputs() {
      const defaults = inputVars()
      Object.keys(defaults).forEach(key => {
        this[key] = defaults[key]
      })
    },
    populateInputs(item) {
      Object.keys(inputVars()).forEach(key => {
        if (this[key.camelToSnakeCase()] === item[key]) return
        this[key] = item[key.camelToSnakeCase()]
      })
    },
  },
}
</script>
